module.exports = __webpack_public_path__ + "f18c18212d5cf09ea7d77514bcd52681.MP3";